import { render } from "./ActasAdministrativas.vue?vue&type=template&id=ba4bd828&scoped=true"
import script from "./ActasAdministrativas.vue?vue&type=script&lang=js"
export * from "./ActasAdministrativas.vue?vue&type=script&lang=js"

import "./ActasAdministrativas.vue?vue&type=style&index=0&id=ba4bd828&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4bd828"]])

export default __exports__